import React, { useEffect, useMemo,useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import * as colors from "@mui/material/colors";
import { useSelector } from "react-redux";
import axios from "axios";
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import { Button, CardActionArea } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export  function RouteDetails(props){

  const { pathUrls } = useSelector((state) => state.direction);
      console.log("this is data",pathUrls)
      const [feature1,setfeature1] = useState()
      const [feature2, setfeature2] = useState()
      const [feature3,setfeature3] = useState()
      const [speed1, setSpeed1] = useState()
      const [cost1,setCost1] = useState()
      const [speed2, setSpeed2] = useState()
      const [cost2,setCost2] = useState()
      const [speed3, setSpeed3] = useState()
      const [cost3,setCost3] = useState()
      const [routeData, setRouteData] = useState();
      const [routeDataDetail, setRouteDataDetail] = useState();

      function close(){
        props.setState(false)
      }

      function getRouteData(path){
        console.log(path)
        axios.get(path).then((response) => {
          console.log(response.data.features)
          setRouteData(response.data.features[0].properties);
          setRouteDataDetail(response.data.features)
        });
      }


  // const routeData = useMemo(
  //   () =>
  //   // coordinates.routeData.features.map((place) => ({
        
        // high_occup: place.properties.high_occup,
        // max_speed: place.properties.max_speed,
        // road_weath: place.properties.road_weath,
        // structural: place.properties.structural,
        // vertical_r: place.properties.vertical_r,
        // mode_of_tr: place.properties.mode_of_tr,
        // functional: place.properties.functional,
        // mode_of_tr: place.properties.mode_of_tr,
  //   //   })),

  //   [pathUrls]
  // );
  useEffect(() => {
    console.log("lenght" ,pathUrls.length)
    if(pathUrls.length > 0){
    getRouteData(pathUrls[0].url)}
  },[pathUrls])

      useEffect(() => {
console.log("this is route data",routeData)

        var speed1 = 0;
        var speed2 =0;
        var speed3 =0;
        var const1 = 0;
        var const2 = 0;
        var const3 = 0;
     
     var vals = []
     {routeDataDetail && routeDataDetail.map((fea) => (
       vals.push(fea)
     ))};
     
     for (let index = 0; index < vals.length; index++) {
       const element = vals[index];
      var pathSeq = element.properties.path_id;

     
   if (pathSeq != '1') {
      var speed = 25;
       const2 = element.properties.agg_cost/1000
       speed2 = const2/speed
       speed2 = (speed2 * 100).toFixed(0)
       const2 = const2.toFixed(2)
       setSpeed2(speed2)
       setCost2(const2)
       setfeature2(element.properties)
     
     } else if (pathSeq == '1') {
      var speed = 60;
       const1 = element.properties.agg_cost/1000
       speed1 = const1/speed
       speed1 = (speed1 * 100).toFixed(0)
       const1 = const1.toFixed(2)
       setSpeed1(speed1)
       setCost1(const1)
       setfeature1(element.properties)
     
     } }
       },[routeData,routeDataDetail])
 
  return (
<Box>
<Card sx={{ maxWidth: 465 , minWidth :465,height:"900px",marginTop:"-300px",marginLeft:"0px",backgroundColor:"white",position:"absolute"}}>
      <CardActionArea>
      <ArrowBackIcon size="small" color="primary" onClick={close} />         
        <CardContent>
        <Card sx={{ minWidth: 275 }}>
        <CardContent>
        <Typography sx={{ fontSize: 16 }} style={{color:"#00acc1"}} color="text.secondary" gutterBottom>
       {/* Source place - {coordinates.sourceName}  */}
        </Typography>
        <Typography sx={{ fontSize: 16 }} style={{color:"#00acc1"}} color="text.secondary" gutterBottom> 
       {/* Destination place - {coordinates.targetName} */}
        </Typography>
        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
        By Car  {cost1}km {speed1}min
        </Typography>
        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
        By Bicycle {cost2}km {speed2}min
        </Typography>
        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
        On foot {cost3}km {speed3}min
        </Typography>
      </CardContent>
    </Card>

        <Card sx={{ minWidth: 275 }}>
        <CardContent>
        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
        {routeData ? routeData.high_occup : null}
        </Typography>
        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
        Maximum speed     {routeData ? routeData.max_speed :null}
        </Typography>
        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
        Road Weather     {routeData ? routeData.road_weath :null}
        </Typography>
        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
        Road Structure     {routeData ? routeData.structural :null}
        </Typography>
        <Typography sx={{ fontSize: 16 }} color="text.secondary" gutterBottom>
        Road functional     {routeData ? routeData.functional:null}
        </Typography>
      </CardContent>
    </Card>

        </CardContent>
      </CardActionArea>
      <CardActions>
      </CardActions>
    </Card>



    
</Box>
    
  );
}